export const updateStorage = async (value, data) => {
	let prevData = await JSON.parse(sessionStorage.getItem(data));
	Object.keys(value).forEach((val) => {
		prevData[val] = value[val];
	});
	sessionStorage.setItem(data, JSON.stringify(prevData));
};
